import {NgModule} from '@angular/core';
import {NgxAnimateCssGridDirective} from './ngx-animate-css-grid.directive';


@NgModule({
  declarations: [NgxAnimateCssGridDirective],
  imports: [],
  exports: [NgxAnimateCssGridDirective]
})
export class NgxAnimateCssGridModule {
}
